import { useState } from "react";
import { useAuth } from "@/App";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Radio, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function LoginPage() {
  const [isRegister, setIsRegister] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const endpoint = isRegister ? "/auth/register" : "/auth/login";
      const { data } = await api.post(endpoint, { username, password });
      login(data.token, data.admin);
      toast.success(isRegister ? "Hesap olusturuldu!" : "Giris basarili!");
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Islem basarisiz");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ background: "radial-gradient(circle at center, #1a1a1a 0%, #000000 100%)" }}
      data-testid="login-page"
    >
      <Card className="w-full max-w-md bg-[#121212] border-[#27272A]">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <div className="w-14 h-14 rounded-xl bg-[#24A1DE]/10 flex items-center justify-center">
              <Radio className="w-7 h-7 text-[#24A1DE]" />
            </div>
          </div>
          <CardTitle className="font-heading text-2xl text-white">
            {isRegister ? "Hesap Olustur" : "Giris Yap"}
          </CardTitle>
          <CardDescription className="text-[#A1A1AA]">
            Telegram Admin Paneli
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="username" className="text-[#A1A1AA] text-sm">Kullanici Adi</Label>
              <Input
                id="username"
                data-testid="username-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin"
                className="bg-[#2C2C2E] border-transparent focus:border-[#24A1DE] text-white h-10"
                required
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password" className="text-[#A1A1AA] text-sm">Sifre</Label>
              <div className="relative">
                <Input
                  id="password"
                  data-testid="password-input"
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="********"
                  className="bg-[#2C2C2E] border-transparent focus:border-[#24A1DE] text-white pr-10 h-10"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-[#A1A1AA] hover:text-white transition-colors"
                  data-testid="toggle-password-visibility"
                >
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <Button
              type="submit"
              data-testid="auth-submit-btn"
              className="w-full bg-[#24A1DE] hover:brightness-110 text-white h-10 font-medium"
              disabled={loading}
            >
              {loading ? "Isleniyor..." : isRegister ? "Kayit Ol" : "Giris Yap"}
            </Button>
            <button
              type="button"
              data-testid="toggle-auth-mode"
              onClick={() => setIsRegister(!isRegister)}
              className="w-full text-sm text-[#A1A1AA] hover:text-[#24A1DE] transition-colors duration-150 py-1"
            >
              {isRegister ? "Zaten hesabiniz var mi? Giris yapin" : "Hesabiniz yok mu? Kayit olun"}
            </button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
